/**
 * URL-based v2 for balanced-lines + projections + related player-line toggles.
 * Set VITE_API_V2_BALANCED_LINES_PROJECTIONS=1 to use /api/v2/... (mirrors v1 behavior until backend diverges).
 */
import { useUserStore } from '../stores/userStore'

// Clients get the V1 fixture views under /fixture/ (see router fixtureViewByRole),
// so for them the URL does not imply the V2 API.
function isClientRole() {
  try {
    return useUserStore().currentUser?.role === 'client'
  } catch {
    return false
  }
}

function isCurrentFixtureV2Path(pathname) {
  if (!pathname) return false
  if (pathname.startsWith('/fixture-v1/')) return false
  if (!(pathname.startsWith('/fixture/') || pathname.startsWith('/fixture-v2/'))) return false
  return !isClientRole()
}

export function useBalancedProjectionsV2() {
  if (typeof window !== 'undefined' && isCurrentFixtureV2Path(window.location.pathname)) {
    return true
  }

  const v = import.meta.env.VITE_API_V2_BALANCED_LINES_PROJECTIONS
  return v === '1' || v === 'true'
}

export function isFixtureV2Route() {
  return typeof window !== 'undefined' && isCurrentFixtureV2Path(window.location.pathname)
}

/** @param {string} path path after /api/, e.g. "balanced-lines/both/12" */
export function apiBalancedProjectionsPath(path) {
  const p = String(path).replace(/^\/+/, '')
  return useBalancedProjectionsV2() ? `/api/v2/${p}` : `/api/${p}`
}
